type ClientMetricEvent =
  | "hotel_reviews_requested"
  | "hotel_reviews_succeeded"
  | "hotel_reviews_failed"
  | "google_places_autocomplete_requested"
  | "google_places_autocomplete_succeeded"
  | "google_places_autocomplete_failed"
  | "google_places_details_requested"
  | "google_places_details_succeeded"
  | "google_places_details_failed";

type ClientMetricOutcome = "requested" | "success" | "error";
type ClientMetricRoute =
  | "hotel_details"
  | "hotel_search"
  | "address_entry"
  | "vehicle_search"
  | "add_hotel"
  | "shared_places";

const EVENT_OUTCOME: Record<ClientMetricEvent, ClientMetricOutcome> = {
  hotel_reviews_requested: "requested",
  hotel_reviews_succeeded: "success",
  hotel_reviews_failed: "error",
  google_places_autocomplete_requested: "requested",
  google_places_autocomplete_succeeded: "success",
  google_places_autocomplete_failed: "error",
  google_places_details_requested: "requested",
  google_places_details_succeeded: "success",
  google_places_details_failed: "error",
};

export function recordClientMetric(
  event: ClientMetricEvent,
  route: ClientMetricRoute = "hotel_details"
): void {
  if (typeof fetch === "undefined") {
    return;
  }

  const payload = {
    event,
    platform: "web",
    route,
    outcome: EVENT_OUTCOME[event],
  };

  fetch("/api/client-metrics", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
    keepalive: true,
  }).catch(() => {
    // Fire-and-forget — metrics should never affect the user flow.
  });
}
